'use client'
import Script from 'next/script'
import { useCookie } from 'web/src/lib/context/cookie-context'
import React from 'react'

type ScriptList = {
    id: string
    script?: string
    src?: string
    loadingStrategy?: 'afterInteractive' | 'worker' | 'beforeInteractive' | 'lazyOnload'
}

const WebsiteScripts = () => {
    const { cookiePreferences } = useCookie()
    const scripts: ScriptList[] = []

    if (cookiePreferences?.statistics) {
        // Add Google Analytics
        if (process.env.NEXT_PUBLIC_GTAG_API_KEY) {
            scripts.push({
                loadingStrategy: 'lazyOnload',
                id: 'google-analytics-script',
                src: `https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GTAG_API_KEY}`,
            })
        }

        // Add Bconnect / Smartsupp chat
        if (process.env.NEXT_PUBLIC_SMARTSUPP_KEY) {
            scripts.push({
                loadingStrategy: 'lazyOnload',
                id: 'smartsupp-chat',
                script:
                    `var _smartsupp = _smartsupp || {};\n` +
                    `_smartsupp.key = '${process.env.NEXT_PUBLIC_SMARTSUPP_KEY}';\n` +
                    `_smartsupp.transcriptEnabled = false;\n` +
                    `_smartsupp.hideWidget = true;\n` +
                    `_smartsupp.cookieDomain = '.mitsubishi-motors.nl';\n` +
                    `window.smartsupp||(function(d) {\n` +
                    `  var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];\n` +
                    `  s=d.getElementsByTagName('script')[0];c=d.createElement('script');\n` +
                    `  c.type='text/javascript';c.charset='utf-8';c.async=true;\n` +
                    `  c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);\n` +
                    `})(document);`,
            })
        }
    }

    return (
        <>
            {scripts?.map(({ loadingStrategy, id, script, src }) => {
                if (src) {
                    return (
                        <Script
                            strategy={loadingStrategy || 'afterInteractive'}
                            type="text/javascript"
                            key={id}
                            id={id}
                            src={src}
                        />
                    )
                } else if (script) {
                    return (
                        <Script
                            strategy={loadingStrategy || 'afterInteractive'}
                            type="text/javascript"
                            key={id}
                            id={id}
                            dangerouslySetInnerHTML={{ __html: script }}
                        />
                    )
                } else {
                    return null
                }
            })}
        </>
    )
}

export default WebsiteScripts
